module.exports = __webpack_public_path__ + "static/media/mira-technology-park-test-track-facilities.13468c71.jpg";